const NOTIFICATION_ENDPOINTS = {
  READALL_NOTIFICATION: "frontend/markReadAll-notifications",
  NOTIFICATION_LIST: "frontend/notifications-list",
  GET_NOTIFICATION_PREFERANCE_CATEGORY:
    "frontend/notification-preferences/categories",
  NOTIFICATION_PREFERANCE: "frontend/notification-preferences",
  ENABLE_ALL_NOTIFICATION: "frontend/notification-preferences/enable-all",
  DISABLE_ALL_NOTIFICATION: "frontend/notification-preferences/disable-all",
  UPDATE_NOTIFICATION_CATEGORY: "frontend/notification-preferences",
  BULK_UPDATE: "frontend/notification-preferences/bulk-update",
};

export default NOTIFICATION_ENDPOINTS;
